import React from "react";

export default class FolientypAuswahl extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    this.props.setFolientyp(e.target.value);
  }

  render() {
    return (
      <div>
        <select id="folientyp" onChange={this.handleChange}>
          <option value="Matt">Medium Matt (51 Farben)</option>
          <option value="MattPremium">Premium Matt (2 Farben)</option>
          <option value="Standard">Medium Glanz (51 Farben)</option>
          <option value="Hochwertig">Premium Glanz (107 Farben)</option>
          <option value="Milchglas">Milchglasfolie (2 Farben)</option>
        </select>
      </div>
    );
  }
}
